import React from 'react';
import utils from "../../utils/utils.functions";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faEdit,
    faLock,
    faLockOpen,
} from '@fortawesome/free-solid-svg-icons';

const customStyles = {
    rows: {
        style: {
        minHeight: '72px', // override the row height
        }
    },
    headCells: {
        style: {
        paddingLeft: '8px', // override the cell padding for head cells
        paddingRight: '8px',
        },
    },
    cells: {
        style: {
        paddingLeft: '8px', // override the cell padding for data cells
        paddingRight: '8px',
        },
    },
};

const productos = (edition, lock) => {
    return [
      {
        name: 'Producto',
        selector: 'nombre_producto',
        sortable: true,
        wrap: true,
      },
      {
        name: 'Precio Unitario',
        selector: 'costo',
        right: true,
        sortable: true,
        cell: row => (
            utils.formatMoney(row.costo)
        )
      },
      {
        name: 'Bloquear/Desbloquear',
        center: true,
        cell: row => (
            <button onClick={() => lock(row)} className="btnx btnx-warn icon-table mt-1 mb-1" {...(!row.estado && { style: { backgroundColor: '#FC2D2D', border: '0px 2px solid #FC2D2D' } } )} >
                <FontAwesomeIcon icon={row.estado ? faLockOpen : faLock} />
            </button>
        )
      },
      {
        name: 'Opciones',
        right: true,
        sortable: true,
        cell: row => (
            <>
                <button onClick={() => edition(row)} className="btnx btnx-warn icon-table mt-1 mb-1">
                    <FontAwesomeIcon icon={faEdit} />
                </button>
            </>
        )
      }
    ]
}


export {
    productos,
    customStyles,
}